<template>
	<div>Professionnels</div>
</template>

<script>
export default {
	name: 'Professionnels',
	data () {
		return {}
	}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Professionnels.vue